/*
  hrc-klaviyo-waitlist.js
  Listener delegado UNICO para toda la web (no se añade un listener por
  tarjeta). Detecta clics/activaciones de teclado sobre cualquier elemento
  con data-hrc-klaviyo-form-id, sanea el ID, evita el comportamiento por
  defecto y abre el formulario de Klaviyo correspondiente via
  window._klOnsite. Funciona igual tras recargas dinamicas de seccion en el
  Theme Editor (shopify:section:load) porque la delegacion vive en
  `document`, no en los nodos de cada tarjeta.
  No expone claves privadas ni carga una segunda copia de klaviyo.js: solo
  empuja a la cola window._klOnsite, igual que hace el snippet de Klaviyo ya
  instalado en la tienda.
*/
(function () {
  var SELECTOR = '[data-hrc-klaviyo-form-id]';

  function sanitizeFormId(raw) {
    if (!raw) return '';
    var id = String(raw).trim();
    // El ID de formulario de Klaviyo es alfanumerico (con guiones/guion bajo
    // opcionales). Cualquier otra cosa (HTML, JS, URLs) se descarta: el ID
    // se trata exclusivamente como texto plano.
    if (!/^[A-Za-z0-9_-]+$/.test(id)) return '';
    return id;
  }

  function openForm(formId) {
    try {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    } catch (err) {
      // Klaviyo puede seguir cargando o no estar disponible: no rompemos la pagina.
    }
  }

  function handleTrigger(trigger, evt) {
    var formId = sanitizeFormId(trigger.getAttribute('data-hrc-klaviyo-form-id'));
    if (!formId) return;
    if (evt && evt.cancelable) evt.preventDefault();
    openForm(formId);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!trigger) return;
    handleTrigger(trigger, e);
  }, false);

  // Accesibilidad: los triggers sin href real (p.ej. <a role="button"
  // tabindex="0">) deben poder activarse tambien con teclado.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var trigger = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!trigger) return;
    if (trigger.tagName === 'BUTTON') return; // el navegador ya dispara click en Enter/Espacio
    handleTrigger(trigger, e);
  }, false);
})();
